import {
  TICK_ANIMATION_DEFAULT_MS,
  TICK_ANIMATION_MIN_MS,
  TICK_ANIMATION_MAX_MS,
  TICK_INTERVAL_SMOOTHING,
} from "../constants";

const clamp = (value, min, max) => Math.min(max, Math.max(min, value));

/**
 * Duration of a tick animation: the smoothed interval between ticks that
 * moved the price, within TICK_ANIMATION_MIN_MS..TICK_ANIMATION_MAX_MS.
 * Frequent ticks give short animations, rare ones long, so the price keeps
 * moving between ticks instead of "move, pause, move".
 */
export const createTickClock = () => {
  let lastTickTime = null;
  let smoothedInterval = TICK_ANIMATION_DEFAULT_MS;

  return {
    /**
     * A tick that moved the price came at `now`.
     *
     * @param {number} now - ms
     * @returns {number} duration of its animation, ms
     */
    record: (now) => {
      if (lastTickTime !== null) {
        const interval = clamp(now - lastTickTime, TICK_ANIMATION_MIN_MS, TICK_ANIMATION_MAX_MS);

        smoothedInterval += (interval - smoothedInterval) * TICK_INTERVAL_SMOOTHING;
      }

      lastTickTime = now;

      return smoothedInterval;
    },

    /** Forgets the last tick, so a pause (hidden tab) is not measured as an interval. */
    restart: () => {
      lastTickTime = null;
    },
  };
};
